'use strict';

(function () {
  'use strict';

  angular.module('vnext').controller('FavoritesCtrl', FavoritesCtrl);

  FavoritesCtrl.$inject = ['$log', 'favorites', 'inspirations', 'activityRouter'];

  /* @ngInject */
  function FavoritesCtrl($log, favorites, inspirations, activityRouter) {
    var vm = this;
    vm.title = 'FavoritesCtrl';
    vm.start = start;

    activate();

    ////////////////

    function activate() {
      var publishedStatus = 'PUBLISHED';

      // Filter out unpublished favorites
      vm.favorites = favorites.filter(function (favorite) {
        return favorite.status === publishedStatus;
      });
      vm.inspirations = inspirations;
    }

    function start(activity) {
      activityRouter.createTrain([activity]);
    }
  }
})();